import React from 'react';
import styles from './styles.module.css';
import ElementTestConfig from '../ElementTestConfig';

const VariantsConfig = ({ testType, formData, onUpdate, onNext }) => {
    // Handle element test updates (UPDATED to handle both button and image)
    const handleElementUpdate = (elementData) => {
        const config = elementData.elementConfig;

        let optimizedElementConfig;

        if (config.elementType === 'button') {
            // Handle button position test
            optimizedElementConfig = {
                testType: 'element',
                elementType: 'button',
                selectedButton: config.selectedButton,
                modifications: {
                    selector: config.modifications.selector,
                    buttonType: config.modifications.buttonType,
                    buttonName: config.modifications.buttonName,
                    pageUrl: config.modifications.pageUrl,
                    style: {
                        original: config.modifications.style.original,
                        test: config.modifications.style.test
                    },
                    text: {
                        original: config.modifications.text.original,
                        test: config.modifications.text.test
                    },
                    position: {
                        original: config.modifications.position.original,
                        test: config.modifications.position.test
                    }
                }
            };
        } else if (config.elementType === 'image') {
            // Handle image replacement test
            optimizedElementConfig = {
                testType: 'element',
                elementType: 'image',
                selectedImage: config.selectedImage,
                modifications: {
                    selector: config.modifications.selector,
                    imageName: config.modifications.imageName,
                    pageUrl: config.modifications.pageUrl,
                    imageReplacement: config.modifications.imageReplacement
                }
            };
        }

        onUpdate({
            variants: optimizedElementConfig
        });
    };

    const handleNext = () => {
        onNext();
    };

    // NEW: Render element test variants (supports both button and image)
    const renderElementVariants = () => {
        return (
            <ElementTestConfig
                testType={testType}
                formData={formData}
                onUpdate={handleElementUpdate}
                onNext={handleNext}
                initialConfig={
                    formData.variants ? reconstructElementConfig(formData.variants) : null
                }
            />
        );
    };

    // UPDATED: Helper: Reconstruct config for ElementTestConfig (supports both button and image)
    const reconstructElementConfig = (variants) => {
        if (!variants || variants.testType !== 'element') return null;

        if (variants.elementType === 'button') {
            return {
                elementType: 'button',
                selectedButton: variants.selectedButton,
                positionConfig: {
                    original: variants.modifications.position.original,
                    test: variants.modifications.position.test
                }
            };
        } else if (variants.elementType === 'image') {
            return {
                elementType: 'image',
                selectedImage: variants.selectedImage,
                replacementConfig: variants.modifications.imageReplacement
            };
        }

        // Fallback for legacy button-only configs
        return {
            elementType: 'button',
            selectedButton: variants.selectedButton,
            modifications: variants.modifications
        };
    };

    const renderVariantsByType = (testType) => {
        console.log('Rendering variants for test type:', testType);
        switch (testType) {
            case 'element':
                return renderElementVariants();
            default:
                return (
                    <div className={styles.notSupported}>
                        <p>Test type "{testType}" is not supported yet</p>
                    </div>
                );
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h2 className={styles.sectionTitle}>Configure Test Variants</h2>
                <p className={styles.sectionDescription}>
                    Set up your control group and test variation
                </p>
            </div>
            <div className={styles.variantsGrid}>
                {renderVariantsByType(testType)}
            </div>
        </div>
    );
};

export default VariantsConfig;